module.exports = __webpack_public_path__ + "static/media/success.887354c9.svg";